import React, { Component } from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Segment,
} from 'semantic-ui-react';

import Utils from '../Utils.js';

class PanelTexts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      capacities: this.props.capacities,
      texts: [{
        position: 0,
        text: 'Twitter',
        placeholder: 'Panel text here',
      }],
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ capacities: nextProps.capacities, });
  }

  onTextChange = (panel, event, data) => {
    let t = this.state.texts;
    t[panel.position].text = data.value;
    this.setState({
      texts: t,
    });
    this.props.onPanelTextsChange(t);
  }

  onAdd = () => {
    let t = this.state.texts;
    t.push({
      position: t.length,
      text: 'Twitter',
      placeholder: 'Panel text here',
    });
    this.setState({
      texts: t,
    });
    this.props.onPanelTextsChange(t);
  }

  onRemove = (panel) => {
    let t = this.state.texts;
    t.splice(panel.position, 1);

    for (var i = 0; i < t.length; i++) {
      t[i].position = i;
    }

    this.setState({
      texts: t,
    });
    this.props.onPanelTextsChange(t);
  }

  render() {
    if (Utils.hasNoneCapacities(this.state.capacities, ['panel_texts'])) {
      return null;
    }

    return (
      <Grid columns={1} stackable>
        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign='left'>
              <Icon name='pencil'/>
              <Header.Content>Panels</Header.Content>
              <Header.Subheader>Panel configuration / content</Header.Subheader>
            </Header>
          </Segment>
        </Grid.Column>

        {this.state.texts.map((panel) => {
          return <Grid.Row key={panel.position} columns={3}>
            <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
              <strong>Panel {panel.position+1}</strong>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <Form.Input error={panel.text.length < 2} size='huge' value={panel.text} onChange={(event, data) => { this.onTextChange(panel, event, data) }} placeholder={panel.placeholder} />
              </Form.Field>
            </Grid.Column>
            <Grid.Column verticalAlign='middle'>
              {panel.position !== 0 &&
                <Icon onClick={() => { this.onRemove(panel); }} name='remove circle' />
              }
            </Grid.Column>
          </Grid.Row>
        })}

        <Grid.Row columns={1}>
          <Grid.Column align='center'>
            <Button disabled={this.state.texts.length >= 4} style={{width: '200px'}}  onClick={this.onAdd}>Add a panel</Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default PanelTexts;



// WEBPACK FOOTER //
// ./src/tool/PanelTexts.js